import { createServiceManifest } from '@estee/elc-service';
import { DISCOVERY, DISCOVERY_GNAV } from '@estee/elc-service-view-names';
import { IManifestServiceRegistryComp } from '@estee/elc-universal-utils';
import { DiscoveryService } from './service-setup/DiscoveryService';

const { name, version } = __serviceInfo__;

const serviceViews = [DISCOVERY, DISCOVERY_GNAV];

const serviceEvents: string[] = [];
const serviceQueries: string[] = [];

export const ServiceManifest: IManifestServiceRegistryComp = createServiceManifest<DiscoveryService>(
    {
        views: serviceViews,
        events: serviceEvents,
        queries: serviceQueries,
        name,
        version
    },
    () =>
        import(
            /* webpackChunkName: 'core' */
            './service-setup/diContainer'
        ),
    'discoveryService'
);
